import { AttachmentUploadFn } from './useFroalaAttachments'
import { ImageUploadFn } from './useRichTextImageUpload'

const useEditorButtons = (
  isFullVersion: boolean = true,
  attachmentUploadFn?: AttachmentUploadFn,
  areGifsSupported = false,
  hideButtons = false,
  imageUploadFn?: ImageUploadFn,
) => {
  if (hideButtons) {
    return {
      moreTextButtons: [],
      moreParagraphButtons: [],
      moreRichButtons: [],
      moreMiscButtons: [],
      pluginsEnabled: [],
    }
  }

  const moreTextButtonsFull = [
    'bold',
    'italic',
    'underline',
    'strikeThrough',
    'insertImage',
    ...(areGifsSupported ? ['insertGif'] : []), // Custom GIF button
    'emoticons',
    ...(attachmentUploadFn ? ['insertAttachment'] : []), // Custom attachment button
    'subscript',
    'superscript',
    'fontFamily',
    'fontSize',
    'textColor',
    'backgroundColor',
    'inlineClass',
    'clearFormatting',
  ]

  const moreParagraphButtonsFull = [
    'alignLeft',
    'alignCenter',
    'formatOLSimple',
    'alignRight',
    'alignJustify',
    'formatOL',
    'formatUL',
    'paragraphFormat',
    'paragraphStyle',
    'lineHeight',
    'outdent',
    'indent',
    'quote',
  ]

  const moreRichButtonsFull = [
    'insertLink',
    // 'insertVideo',
    'insertTable',
    'fontAwesome',
    'specialCharacters',
    // 'embedly',
    // 'insertFile',
    // 'insertHR',
  ]

  const moreMiscButtonsFull = [
    'undo',
    'redo',
    // 'fullscreen',
    // 'print',
    // 'getPDF',
    // 'spellChecker',
    // 'selectAll',
    // 'html',
    // 'help',
  ]

  const pluginsEnabledFull = [
    'charCounter',
    'table',
    'spell',
    'quote',
    'save',
    'paragraphFormat',
    'paragraphStyle',
    'help',
    'draggable',
    'align',
    'link',
    'lists',
    'file',
    'image',
    'emoticons',
    'url',
    'video',
    'embedly',
    'colors',
    'entities',
    'inlineClass',
    'inlineStyle',
    'imageTUI',
  ]

  const moreTextButtons = [
    'bold',
    'italic',
    'underline',
    ...(imageUploadFn ? ['insertImage'] : []),
    ...(areGifsSupported ? ['insertGif'] : []), // Custom GIF button
    'emoticons',
    ...(attachmentUploadFn ? ['insertAttachment'] : []), // Custom attachment button
    'formatOLSimple',
    'formatUL',
  ]

  return {
    moreTextButtons: isFullVersion ? moreTextButtonsFull : moreTextButtons,
    moreParagraphButtons: isFullVersion ? moreParagraphButtonsFull : [],
    moreRichButtons: isFullVersion ? moreRichButtonsFull : [],
    moreMiscButtons: isFullVersion ? moreMiscButtonsFull : [],
    pluginsEnabled: pluginsEnabledFull,
  }
}

export default useEditorButtons
